import React, {Component} from 'react';
import map from "lodash/map";
import {connect} from "react-redux";
import Box from "@material-ui/core/Box";
import {DisplayOnHoverBox} from "amn/ui/containers/Boxes";
import {
  selectSecurityStandards,
  selectSecurityStandardsDataStatus
} from "amn/store/selectors/standards/security-standards.selectors";
import LoadingContainer from "amn/ui/containers/LoadingContainer";
import type {DataStatus} from "amn/store/reducers/common";
import {DATA_LOADING} from "amn/store/reducers/common";
import type {SecurityStandard} from "amn/model/standards/SecurityStandards";
import type {LookupTable} from "amn/model/common/Divers";
import {NavLink} from "react-router-dom";
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import {Tooltip} from "amn/ui/diverse/ToolTips";
import I18n from "amn/ui/i18n/I18n";
import {I18N_NS_STANDARDS} from "amn/common/i18n/I18nextConfig";
import {buildStandardUrl} from "../../../common/routes/standards-routes";
import TruncatedText from "amn/ui/diverse/TruncatedText";
import NewBadge from "./NewBadge";

type Props = {
  securityStandards: LookupTable<SecurityStandard>;
  dataStatus: DataStatus;
};

type State = {};

class SecurityStandardsViewer extends Component<Props, State> {


  render() {
    const {securityStandards, dataStatus} = this.props;
    return (
      <Box p={2}>
        <LoadingContainer loading={dataStatus === DATA_LOADING}>
          <Box>

            {
              map(securityStandards, (standard: SecurityStandard) => {
                return (
                  <Tooltip key={standard.id}
                           title={(
                             <I18n ns={I18N_NS_STANDARDS} i18nKey="standards.clickToOpen">
                               Click To Open
                             </I18n>
                           )}>
                    <DisplayOnHoverBox component={NavLink}
                         to={buildStandardUrl(standard.id)}
                         display="flex"
                         alignItems="center"
                         mb={1}
                         bgcolor="background.paper"
                         borderRadius="borderRadius"
                         style={{textDecoration: 'none', color: 'inherit'}}>
                      {
                        (isHovered) => (
                          <Box width="100%"
                               display="flex"
                               alignItems="center"
                               style={{
                                 cursor: 'pointer',
                                 borderWidth: 1,
                                 borderStyle: "solid",
                                 borderColor: isHovered ? "rgba(0, 0, 0, 0.12)" : "transparent",
                                 borderRadius: 4
                               }}>
                            <Box color="primary.main" mr={2} ml={2} display="flex">
                              <AccountBalanceOutlinedIcon/>
                            </Box>
                            
                            <Box display="flex" flexDirection="column" flexGrow={1} py={2} pr={2}>
                              <Box display="flex" alignItems="center">
                                <Box fontWeight="fontWeightMedium" color="secondary.main">
                                  {standard.name}
                                </Box>
                                {
                                  standard.new && (
                                    <NewBadge />
                                  )
                                }
                              </Box>
                        <Box mt={0.5}>
                          <TruncatedText text={standard.description || ""} fontSize="caption.fontSize" color="text.secondary" lines={2} />
                        </Box>
                            </Box>
                          </Box>
                        )
                      }
                    </DisplayOnHoverBox>
                  </Tooltip>
                )
              })
            }
          </Box>
        </LoadingContainer>
      </Box>
    );
  }

  static mapStateToProps = (state) => {
    return {
      dataStatus: selectSecurityStandardsDataStatus(state),
      securityStandards: selectSecurityStandards(state)
    }
  };
}


export default connect(SecurityStandardsViewer.mapStateToProps)(SecurityStandardsViewer);




